import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { BoletimCompleto } from '../models/portal.models';
import { PortalBackendService } from '../services/portal-backend.service';
import { RelatorioDialogComponent } from '../relatorio-dialog/relatorio-dialog';

@Component({
  selector: 'app-boletim',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatIconModule],
  templateUrl: './boletim.html',
  styleUrls: ['./boletim.scss'] // Corrigido de 'styleUrl' para 'styleUrls' (padrão do Angular CLI)
})
export class BoletimComponent {
  @Input() boletim: BoletimCompleto | null = null;
  @Input() carregando = false;
  @Input() alunoId: number | undefined; // Propriedade adicionada
  @Input() turmaId: number | undefined; // Propriedade para ID da turma, caso seja necessária para o relatório

  // Cores para cada bimestre (não utilizado no momento, mas mantido)
  private coresBimestres = ['#0fa3ad', '#f39c12', '#9b59b6', '#e74c3c'];

  constructor(
    private dialog: MatDialog,
    private backendService: PortalBackendService
  ) {}

  abrirRelatorioPeriodo(alunoId: number | undefined, criterioAvaliacaoId: number | undefined, turmaId: number | undefined,
    turmaDisciplinaId?: number | undefined
  ) {
    console.log('Abrindo relatório para alunoId:', alunoId, 'criterioAvaliacaoId:', criterioAvaliacaoId, 'turmaId:', turmaId);

    if (alunoId === undefined || criterioAvaliacaoId === undefined || turmaId === undefined || turmaDisciplinaId === undefined) {
      console.error('ID do aluno, do critério de avaliação ou da turma não fornecido.');
      return;
    }

    this.backendService.getRelatorioPeriodo(alunoId, criterioAvaliacaoId, turmaId, turmaDisciplinaId).subscribe(response => {
      const relatorio = response?.body?.relatorio;

      if (relatorio) {
        this.dialog.open(RelatorioDialogComponent, {
          width: '1200px',
          data: {
            titulo: criterioAvaliacaoId === -1 ? "Relatório Anual" : "Relatório do Período",
            conteudo: relatorio
          }
        });
      } else {
        console.warn('Conteúdo do relatório não encontrado na resposta da API.');
        // Aqui você poderia, opcionalmente, mostrar um alerta para o usuário.
      }
    });
  }

  getCorBimestre(index: number): string {
    return this.coresBimestres[index % this.coresBimestres.length];
  }
}
